const disableConsoleInProduction = () => {
  if (process.env.NODE_ENV === 'prod') {
    console.log = () => {};
    console.info = () => {};
    console.warn = () => {};
    console.error = () => {};
    console.debug = () => {};
  }
};

export default disableConsoleInProduction;
